import * as THREE from 'three'
import * as dat from 'lil-gui'
import gsap from 'gsap'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import jqueryScrollify from 'jquery-scrollify'
import jquery from 'jquery'

/**
 * Debug
 */
// const gui = new dat.GUI()

// const parameters = {
//     materialColor: '#ffeded'
// }

// gui
//     .addColor(parameters, 'materialColor')
//     .onChange(() =>
//     {
//         material.color.set(parameters.materialColor)
//     })



/**
 * Base
 */
// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

/**
 * Objects
 */

/**Texture */
const textureLoader = new THREE.TextureLoader()
const gradientTexture = textureLoader.load('textures/gradients/3.jpg')
gradientTexture.magFilter = THREE.NearestFilter


/*Material*/
// const material = new THREE.MeshToonMaterial({
//     color: parameters.materialColor,
//     gradientMap: gradientTexture
// })

/*Models*/
const gltfLoader = new GLTFLoader()


let model = null
gltfLoader.load('./model/glendruid_three.glb',
        (gltf) =>
        {
            model = gltf.scene.children[0]
            scene.add(model)
            model.position.x=0
            model.position.y= 0
            model.position.z=0
            // model.rotation.y= Math.PI /0.75
            model.rotation.y=0
            model.rotation.z=0
            model.rotation.x=0

            if (sizes.width <= 450) {
                model.position.x=0
                model.position.y= 0.5
                model.position.z=0
            }
        }
)





/*Meshes*/
const objectsDistance = 4

// const mesh1 = new THREE.Mesh(
//     new THREE.TorusGeometry(1,0.4,16,60),
//     material
// )

// const mesh2 = new THREE.Mesh(
//     new THREE.ConeGeometry(1,2,32),
//     material
// )

// const mesh3 = new THREE.Mesh(
//     new THREE.TorusKnotGeometry(0.8,0.35,100,16),
//     material
// )

// mesh1.position.y = objectsDistance * 0
// mesh2.position.y = objectsDistance * -1
// mesh3.position.y = objectsDistance * -2


// mesh1.position.x = 2
// mesh2.position.x = -2
// mesh3.position.x = 2



// scene.add(mesh1,mesh2,mesh3)

// const sectionMeshes = [mesh1, mesh2, mesh3]

/**
 * Particels
 */

//Geometry
// const particlesCount = 200
// const positions = new Float32Array(particlesCount*3)

// for(let i=0; i<particlesCount;i++)
// {
//     positions[i*3+0] = (Math.random() - 0.5)*10
//     positions[i*3+1] = objectsDistance * 0.5 -Math.random()*objectsDistance * sectionMeshes.length
//     positions[i*3+2] = (Math.random() - 0.5)*10
// }

// const particlesGeometry = new THREE.BufferGeometry()
// particlesGeometry.setAttribute('position', new THREE.BufferAttribute(positions, 3))

//Material
// const particlesMaterial = new THREE.PointsMaterial({
//     color: parameters.materialColor,
//     sizeAttenuation:true,
//     size: 0.03

// })

//Points
// const particles = new THREE.Points(particlesGeometry, particlesMaterial)
// scene.add(particles)

/**
 * Lights
 */
// const directionalLight = new THREE.DirectionalLight('#ffffff', 1)
// directionalLight.position.set(1,1,0)
// scene.add(directionalLight)

const ambientLight = new THREE.AmbientLight('#ffffff',1)
scene.add(ambientLight)


/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}




window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})





/**
 * Camera
 */
const cameraGroup = new THREE.Group()
scene.add(cameraGroup)

// Base camera
const camera = new THREE.PerspectiveCamera(35, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 2.87
camera.position.y = 2.16
camera.position.z = -1.31

camera.lookAt(0,0,0)
// gui.add(camera.position, 'x',-10,10,0.01)
// gui.add(camera.position, 'y',-1,10,0.01)
// gui.add(camera.position, 'z',-10,10,0.01)
cameraGroup.add(camera)







//update object for mobile
if (sizes.width <= 450) {
    // mesh1.position.x = 0;
    // mesh1.position.y = -2;
    camera.position.z = 12
    camera.position.y = 5
}



/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    alpha:true
})


renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

// Orbit Controls
const controls = new OrbitControls( camera, renderer.domElement );
controls.enabled = false
/**
 * Scroll
 */
let scrollY = window.scrollY
let currentSection = 0

//desktop
if (sizes.width >= 450) {
    
    window.addEventListener('scroll', () =>
    {
        scrollY = window.scrollY

        const newSection = Math.round(scrollY /sizes.height)
        console.log(newSection)
        console.log(scrollY)
        if(newSection == 0)
        {
            currentSection = newSection

            
            gsap.to(
                model.rotation,
                {
                    duration:2,
                    ease: 'Power2.inOut',
                    
                    // x: 0,
                    // y: Math.PI /0.75,
                    // z: 0,
                
                }
            )
            gsap.to(
                model.position,
                {
                    duration:2,
                    ease: 'Power2.inOut',
                   
                     x: 0,
                     y: 0,
                     z: 0
                }
            )
            gsap.to(
                camera.position,
                {
                    duration:2,
                    ease: 'Power2.inOut',
                   
                    x : 2.87,
                    y : 2.16,
                    z : -1.31
                }
            )
            // camera.lookAt(0,2,0)
            controls.enabled = false
        }

        if(newSection == 1)
        {
            currentSection = newSection

            gsap.to(
                model.rotation,
                {
                    duration:2,
                    ease: 'Power2.inOut',
                    
                    // x: 0,
                    // y: 0,
                    // z: 0
                
                    
                }
            )
            gsap.to(
                model.position,
                {
                    duration:2,
                    ease: 'Power2.inOut',
                    
                     x: 2,
                     y:1,
                     z: 0
                }
            )
            gsap.to(
                camera.position,
                {
                    duration:2,
                    ease: 'Power2.inOut',
                   
                    x: 5.3,
                    y: 3,
                    z: 4
                }
            )
            // camera.lookAt(0,2,0)
            controls.enabled = false
        }

        if(newSection == 2)
        {
            currentSection = newSection

            gsap.to(
                model.rotation,
                {
                    duration:2,
                    ease: 'Power2.inOut',
                    
                    // x: 0,
                    // y: 0.75,
                    // z: 0
                    
                }
            )
            gsap.to(
                model.position,
                {
                    duration:2,
                    ease: 'Power2.inOut',
                     x: 1,
                    z: 0,
                    y: 0
                    
                }
            )
            gsap.to(
                camera.position,
                {
                    duration:2,
                    ease: 'Power2.inOut',
                   
                    x: -2.29,
                    y: 0,
                    z: 2.87
                }
            )
            controls.enabled = false
            
        }

        if(newSection == 3)
        {
            currentSection = newSection

            gsap.to(
                model.rotation,
                {
                    duration:2,
                    ease: 'Power2.inOut',
                    
                    // x: 0,
                    // y: Math.PI * -1,
                    // z: 0
                }
            )
            gsap.to(
                model.position,
                {
                    duration:2,
                    ease: 'Power2.inOut',
                     x: -0.5,
                     y: 0.25,
                    z: 0
                }
            )
            gsap.to(
                camera.position,
                {
                    duration:2,
                    ease: 'Power2.inOut',
                   
                    x: -1,
                    y: 0.4,
                    z: -3
                }
            )
            // camera.lookAt(0,0,0)
            controls.enabled = false
        }
        if(newSection == 4)
        {
            currentSection = newSection

            gsap.to(
                model.rotation,
                {
                    duration:2,
                    ease: 'Power2.inOut',
                    
                    // x: 0,
                    // y: Math.PI * -1,
                    // z: 0
                }
            )
            gsap.to(
                model.position,
                {
                    duration:2,
                    ease: 'Power2.inOut',
                     x: 0,
                     y: 0,
                     z: -1
                }
            )
            gsap.to(
                camera.position,
                {
                    duration:2,
                    ease: 'Power2.inOut',
                   
                    x: 3,
                    y: -0.14,
                    z: -0.08
                }
            )
            // camera.lookAt(0,0,0)
            controls.enabled = false
        }
        if(newSection == 5)
        {
            currentSection = newSection
          
            gsap.to(
                model.rotation,
                {
                    duration:2,
                    ease: 'Power2.inOut',
                    
                    // x: 0,
                    // y: Math.PI * -1,
                    // z: 0
                }
            )
            gsap.to(
                model.position,
                {
                    duration:2,
                    ease: 'Power2.inOut',
                     x: 2,
                     y: 0,
                     z: 0
                }
            )
            gsap.to(
                camera.position,
                {
                    duration:2,
                    ease: 'Power2.inOut',
                   
                    x: -3.03,
                    y: 1.75,
                    z: 5.08
                }
            )
            // camera.lookAt(0,0,0)
            controls.enabled = false
        }
        if(newSection == 6)
        {
            controls.enabled = true
            controls.enableZoom = false
            currentSection = newSection
            
            
            if(controls.enabled == true){
                console.log("enabled")
            }
            gsap.to(
                model.position,
                {
                    duration:2,
                    ease: 'Power2.inOut',
                     x: 0,
                     y: 0,
                     z: 0
                }
            )
            gsap.to(
                camera.position,
                {
                    duration:0.5,
                    ease: 'Power2.inOut',
                   
                    x: -3.03,
                    y: 1.75,
                    z: 5.08
                }
            )
            
        }
    })
}






//MOBILE ANIMATIONS
else{
    
    
    window.addEventListener('scroll', () =>
    {
        scrollY = window.scrollY

        const newSection = Math.round(scrollY /sizes.height)
        console.log(newSection)
        if(newSection == 0)
        {
            currentSection = newSection

            
            gsap.to(
                model.rotation,
                {
                    duration:2,
                    ease: 'Power2.inOut',
                    
                    // x: 0,
                    // y: Math.PI /0.75,
                    // z: 0,
                
                }
            )
            gsap.to(
                model.position,
                {
                    duration:2,
                    ease: 'Power2.inOut',
                   
                     x: 0,
                     y: -1,
                     z: 0
                }
            )
            gsap.to(
                camera.position,
                {
                    duration:2,
                    ease: 'Power2.inOut',
                   
                    x : 2.87,
                    y : 2.16,
                    z : 12
                }
            )
            // camera.lookAt(0,2,0)
        }

        if(newSection == 1)
        {
            currentSection = newSection

            

            gsap.to(
                model.rotation,
                {
                    duration:2,
                    ease: 'Power2.inOut',
                    
                    // x: 0,
                    // y: 0,
                    // z: 0
                
                    
                }
            )
            gsap.to(
                model.position,
                {
                    duration:2,
                    ease: 'Power2.inOut',
                    
                     x: 0,
                     y: -0.5,
                    z: 0
                }
            )
            gsap.to(
                camera.position,
                {
                    duration:2,
                    ease: 'Power2.inOut',
                   
                    x: 5.84,
                    y: 2.83,
                    z: 4.46
                }
            )
            // camera.lookAt(0,2,0)
        }

        if(newSection == 2)
        {
            currentSection = newSection

            gsap.to(
                model.rotation,
                {
                    duration:2,
                    ease: 'Power2.inOut',
                    
                    // x: 0,
                    // y: 0.75,
                    // z: 0
                    
                }
            )
            gsap.to(
                model.position,
                {
                    duration:2,
                    ease: 'Power2.inOut',
                     x: 0,
                     z: 0,
                     y: -1.5
                    
                }
            )
            gsap.to(
                camera.position,
                {
                    duration:2,
                    ease: 'Power2.inOut',
                   
                    x: -4.41,
                    y: 0.4,
                    z: 8.06
                }
            )
            // camera.lookAt(0,2,0)
        }

        if(newSection == 3)
        {
            currentSection = newSection

            gsap.to(
                model.rotation,
                {
                    duration:2,
                    ease: 'Power2.inOut',
                    
                    // x: 0,
                    // y: Math.PI * -1,
                    // z: 0
                }
            )
            gsap.to(
                model.position,
                {
                    duration:2,
                    ease: 'Power2.inOut',
                     x: 0,
                     y: -1,
                    // z: 0.2
                }
            )
            gsap.to(
                camera.position,
                {
                    duration:2,
                    ease: 'Power2.inOut',
                   
                    x: -1.37,
                    y: 1.77,
                    z: -8.3
                }
            )
        }
        if(newSection == 4)
        {
            currentSection = newSection

            gsap.to(
                model.rotation,
                {
                    duration:2,
                    ease: 'Power2.inOut',
                    
                    // x: 0,
                    // y: Math.PI * -1,
                    // z: 0
                }
            )
            gsap.to(
                model.position,
                {
                    duration:2,
                    ease: 'Power2.inOut',
                     x: 0,
                     y: -1,
                    // z: 0.2
                }
            )
            gsap.to(
                camera.position,
                {
                    duration:2,
                    ease: 'Power2.inOut',
                   
                    x: 7.23,
                    y: 0,
                    z: 0
                }
            )
        }
        if(newSection == 5)
        {
            currentSection = newSection

            gsap.to(
                model.rotation,
                {
                    duration:2,
                    ease: 'Power2.inOut',
                    
                    // x: 0,
                    // y: Math.PI * -1,
                    // z: 0
                }
            )
            gsap.to(
                model.position,
                {
                    duration:2,
                    ease: 'Power2.inOut',
                     x: 0,
                     y: -1.5
                    // z: 0.2
                }
            )
            gsap.to(
                camera.position,
                {
                    duration:2,
                    ease: 'Power2.inOut',
                   
                    x: 0,
                    y: 0,
                    z: 7.5
                }
            )
        }
        if(newSection == 6)
        {
            controls.enabled = true
            controls.enableZoom = false
            currentSection = newSection
            
            
            if(controls.enabled == true){
                console.log("enabled")
            }
            gsap.to(
                model.position,
                {
                    duration:2,
                    ease: 'Power2.inOut',
                     x: 0,
                     y: 0,
                    z: 0
                }
            )
        }
    })
}
/**
 * Cursor
 */
const cursor = {}
cursor.x = 0
cursor.y = 0

window.addEventListener('mousemove', (event)=>
{
    cursor.x = event.clientX / sizes.width - 0.5
    cursor.y = event.clientY / sizes.height - 0.5        
})

/**
 * Animate
 */
const clock = new THREE.Clock()
let previousTime = 0


//Axes Helper - uncomment to set see 3d axis
// const axesHelper = new THREE.AxesHelper( 5 );
// scene.add( axesHelper );

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()
    const deltaTime = elapsedTime - previousTime
    previousTime = elapsedTime



    //Animate Camera

    //camera.position.y = -scrollY /sizes.height*objectsDistance

    if(model !== null){
        
    const parallaxX = cursor.x * 0.2
    const parallaxY = - cursor.y * 0.3
    cameraGroup.rotation.y += (parallaxX - cameraGroup.rotation.y) * 5 *deltaTime
    cameraGroup.position.y += (parallaxY - cameraGroup.position.y) * 5 *deltaTime
    }
    //Animate Meshes
    // for(const mesh of sectionMeshes)
    // {
    //     mesh.rotation.x += deltaTime * 0.1
    //     mesh.rotation.y += deltaTime * 0.12
    // }

    camera.lookAt(0,0,0)

   
    
    // controls.update()
    

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()

    



//Scroll System
$(document).ready(function () {
    $.scrollify({
        section: '.scroll',
        sectionName: 'section-name',
        // standardScrollElements: 'section',
        easing: 'easeOutExpo',
        scrollSpeed: 1100,
        offset:0,
        scrollbars:false,
        setHeights:true,
        overflowScroll: true,
        updateHash: false,
        touchScroll: true,
    })

        $('.scroll-control .one').click(function(){
            $.scrollify.move('#s-one')
        })
        $('.scroll-control .two').click(function(){
            $.scrollify.move('#s-two')
        })
        $('.scroll-control .three').click(function(){
            $.scrollify.move('#s-three')
        })
        $('.scroll-control .four').click(function(){
            $.scrollify.move('#s-four')
        })
        $('.scroll-control .five').click(function(){
            $.scrollify.move('#s-five')
        })
        $('.scroll-control .six').click(function(){
            $.scrollify.move('#s-six')
        })
        $('.scroll-control .seven').click(function(){
            $.scrollify.move('#s-seven')
        })

})
